module.exports = __webpack_public_path__ + "static/media/pgp_glass.37332762.svg";